<template>
<img src="/static/img/icons/android-launchericon-144-144.png" alt="coworking bratislava progressbar logo blockchain">
</template>

<script>
export default {
  name: 'progressbar-logo-icon',
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// ProgressbarLogoIcon.vue?28e8fdad